import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CulinaryService } from '../../core/culinary-service';
import { ContentPageLayout } from '../../shared/layouts/content-page-layout/content-page-layout';
import { SearchableDropdown } from '../../shared/components/searchable-dropdown/searchable-dropdown';
import { EditableInstruction } from '../../shared/components/editable-instruction/editable-instruction';
import { Badge } from '../../shared/components/badge/badge';
import { Icon } from '../../shared/components/icon/icon';
import { Spinner } from '../../shared/components/spinner/spinner';
import { EditIngredientModal } from './edit-ingredient-modal/edit-ingredient-modal';
import { EditTagsModal } from './edit-tags-modal/edit-tags-modal';

@Component({
  selector: 'app-recipe',
  standalone: true,
  imports: [
    ContentPageLayout,
    Badge,
    FormsModule,
    EditableInstruction,
    Icon,
    EditIngredientModal,
    Spinner,
    SearchableDropdown,
    EditTagsModal,
  ],
  templateUrl: './recipe.html',
  styleUrl: './recipe.css',
})
export class Recipe implements OnInit {
  recipe: any = {};
  original_recipe: any = {};
  diets: string[] = [];
  quantity: number = 1;
  units: any = {};
  availableIngredients: any[] = [];
  availableTags: any[] = [];
  isEditing: boolean = false;
  isEditingIngredient: boolean = false;
  isEditingTags: boolean = false;
  currentIngredient: any | null = { name: 'Salt' };
  ingredientDraft: any = {};
  private cdr = inject(ChangeDetectorRef);

  constructor(
    private route: ActivatedRoute,
    private culinaryService: CulinaryService,
  ) {}

  sanitizeIngredients() {
    this.recipe.compositions = this.recipe.compositions.filter((c: any) => {
      const isValid = c.contained_item?.id != null && c.unit?.id != null && c.quantity != null;
      console.log('Item:', c.contained_item?.name, 'Valid:', isValid);
      return isValid;
    });
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      const id = Number(params.get('id'));
      if (id) {
        this.loadRecipe(id);
      }
      this.isEditing = Boolean(params.get('editMode'));
    });
    this.loadUnits();
    this.loadAvailableIngredients();
    this.loadAvailableTags();
  }

  loadRecipe(id: number) {
    this.culinaryService.getRecipeById(id).subscribe({
      next: (data) => {
        this.loadRecipeWithProperties(data);
      },
    });
  }

  loadRecipeWithProperties(recipe: any) {
    this.recipe = recipe;
    this.original_recipe = structuredClone(recipe);
    this.quantity = this.recipe.quantity;
    this.diets = this.culinaryService.getDietsAsStrings(this.recipe);
    this.cdr.detectChanges();
  }

  loadAvailableIngredients() {
    this.culinaryService.getIngredients().subscribe({
      next: (data) => {
        this.availableIngredients = data;
        this.cdr.detectChanges();
        console.log('ingredients:', this.availableIngredients);
      },
    });
  }

  loadAvailableTags() {
    this.culinaryService.getTags().subscribe({
      next: (data) => {
        this.availableTags = data;
        this.cdr.detectChanges();
        console.log('tags:', this.availableTags);
      },
    });
  }

  loadUnits() {
    this.culinaryService.getUnits().subscribe({
      next: (data) => {
        this.units = data;
        this.cdr.detectChanges();
      },
    });
  }

  increaseQuantity() {
    this.quantity++;
  }

  decreaseQuantity() {
    this.quantity--;
  }

  toggleEditMode() {
    if (this.isEditing) {
      this.recipe.quantity = this.quantity;
    }
    this.isEditing = !this.isEditing;
  }

  openEditIngredientModal(ingredient: any) {
    this.currentIngredient = ingredient;
    this.ingredientDraft = structuredClone(this.currentIngredient);
    this.isEditingIngredient = true;
  }

  updateIngredient() {
    const index = this.recipe.compositions.indexOf(this.currentIngredient);

    if (index !== -1) {
      this.recipe.compositions[index] = structuredClone(this.ingredientDraft);
    }
    this.isEditingIngredient = false;
  }

  addIngredient() {
    const ingredient = {
      contained_item: {},
      unit: {},
    };
    this.recipe.compositions.push(ingredient);
    this.openEditIngredientModal(this.recipe.compositions.at(-1));
  }

  removeIngredient() {
    this.recipe.compositions = this.recipe.compositions.filter(
      (c: any) => c !== this.currentIngredient,
    );
  }

  createInstruction() {
    this.recipe.instructions.push({ step_number: 0, summary: '', Details: '' });
  }

  deleteInstruction(instruction: any) {
    this.recipe.instructions = this.recipe.instructions.filter((i: any) => i !== instruction);
  }

  deleteTag(tag_id: number) {
    this.recipe.tags = this.recipe.tags.filter((t: any) => {
      return t.id !== tag_id;
    });
  }

  updateTags(newTags: any[]) {
    console.log('new tags', newTags);
    this.recipe.tags = newTags;
  }

  openEditTagsModal() {
    this.isEditingTags = true;
  }

  saveChanges() {
    console.log('Saving item:', this.recipe);
    this.recipe.quantity = this.quantity;
    this.culinaryService.updateCulinaryItem(this.recipe).subscribe({
      next: (data) => {
        this.loadRecipeWithProperties(data);
      },
    });
    this.toggleEditMode();
  }

  discardChanges() {
    this.loadRecipeWithProperties(structuredClone(this.original_recipe));
    this.toggleEditMode();
  }
}
